const Data = [
    {
        name: "Shivani Aligeti",
        position: "Design Head",
        imageUrl: "/assets/images/members/Heads21/Shivani Aligeti.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Kadasi Namrata",
        position: "Design Head",
        imageUrl: "/assets/images/members/Heads21/Kadasi Namrata.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
]

export default Data;